import { palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const ProviderCardPractitionerItem = styled.button`
  background-color: ${palette.neutral.white};
  border: none;
  padding: 0 1rem;
  cursor: pointer;
  width: calc(100% + 2rem);
  margin: 0 0 0 -1rem;

  article {
    display: grid;
    grid-template-columns: 1fr 2rem;
    border-top: 1px solid ${palette.neutral['grey-ebebeb']};
    text-align: left;
    padding: 0.625rem 0.25rem;
    width: 100%;
    align-items: center;
  }
  &:nth-of-type(2) {
    margin-top: 0.5rem;
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          article:hover {
            background-color: #f7f4e6;
            border-radius: 10px;
            border-color: transparent;
          }

          &&:hover + && {
            article {
              border-color: transparent;
            }
          }
        `
      default:
        return css`
          &:hover {
            background-color: #f7f4e6;
          }
        `
    }
  }}

  h3 {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    font-size: 1rem;
    margin-bottom: 0.125rem;
    color: ${palette.brand.darkGreen};

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            font-weight: 500;
          `
        default:
          return css`
            font-weight: bold;
          `
      }
    }}

    > svg {
      margin-left: 0.5rem;
    }
  }

  span {
    font-size: 0.875rem;
    grid-row: 2;
    color: ${palette.brand.gray};

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            font-weight: 500;
          `
        default:
          return css`
            font-weight: 400;
          `
      }
    }}
  }

  svg {
    grid-column: 2;
    grid-row: 1 / span 2;
  }
`
